import { countWord, listOf } from './pluralise.js';

/** A pull's toast: what it says, and whether it is good news. */
export type PullNotice = { message: string; color: 'green' | 'red' };

/** One **Pull now**: the environment and what changed, or why it refused. */
export const pullNotice = (result: {
    environment: string;
    ok: boolean;
    error?: string;
    total: number;
    fetched: number;
}): PullNotice =>
    result.ok
        ? {
              message: `Pulled ${result.environment}: ${countWord(result.total, 'record')}, ${result.fetched} changed`,
              color: 'green',
          }
        : { message: `${result.environment}: ${result.error}`, color: 'red' };

/** A whole **Pull all**, as one toast: how many, and which failed by name. */
export const pullAllNotice = (outcomes: readonly { environment: string; ok: boolean }[]): PullNotice => {
    const failed = outcomes.filter((o) => !o.ok).map((o) => o.environment);
    if (failed.length === 0) return { message: `Pulled ${countWord(outcomes.length, 'environment')}`, color: 'green' };
    return {
        message: `Pulled ${outcomes.length - failed.length} of ${countWord(outcomes.length, 'environment')}; ${listOf(failed)} failed`,
        color: 'red',
    };
};
